import { createStore } from 'zustand/vanilla';

export const widgetStore = createStore((set) => ({
  status: null,
  images: [],
  originalImageURL: null,
  selectedImageURL: null,
  selectedImageID: null,
  errors: [],
  updateStatus: (status) => set({status: status}),
  updateImages: (images) => set({images: images}),
  updateSelectedImageURL: (selectedImageURL) => set({selectedImageURL: selectedImageURL}),
  updateSelectedImageID: (id) => set({selectedImageID: id}),
  removeSelectedImage: () => set({selectedImageURL: null, selectedImageID: null}),
  updateOriginalImage: (originalImageURL) => set({originalImageURL: originalImageURL}),
  updateErrors: (errors) => set({errors: errors}),
}));
